window.addEventListener("product:added", addItemToCart);

const meta_data = JSON.parse(document.querySelector('#circuly-meta-data')?.innerHTML?.replace(/\s/g, ''));
// const variant_id = hiddenInput.value;


function setPayload(variant_id,meta) {
  // console.log(meta);
	return {  
     	sku: variant_id || null,
  		subscription: meta?.subscription ?? true,
  		quantity: 1,
        subscription_period: "monthly",
  		subscription_interval : meta?.subscription_interval || 1,
        subscription_length : meta?.subscription_length || null
     }
};

function getVariant(){
  const hiddenInput = document.querySelector('input[name="id"]');
  const variant_id = hiddenInput.value;
  return variant_id;
}

function addItemToCart() {
  const variant_id = getVariant();
  const payload = setPayload(variant_id, meta_data[variant_id]);
  let addItemEvent = new CustomEvent("circuly-add-to-cart", {
  detail: {
  		...payload
    }
  });
  dispatchEvent(addItemEvent)
}